import { StandardEvents } from '@shopify/events';

class AlQuantityTiers extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.form = this.closest('form');
    this.component = this.closest('product-form-component');
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.money = new Intl.NumberFormat(this.dataset.locale || 'en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD' });
    this.addEventListener('change', event => {
      if (!event.target.matches('input[type="radio"]')) return;
      const input = this.form.querySelector('input[name="quantity"]');
      if (!input) return;
      input.value = event.target.value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this.refresh();
    }, { signal });
    this.form.addEventListener('change', () => this.refresh(), { signal });
    this.form.addEventListener('input', event => {
      if (event.target.name === 'quantity') this.refresh();
    }, { signal });
    document.addEventListener(StandardEvents.productSelect, async event => {
      const section = this.closest('.shopify-section');
      if (!section?.contains(event.target)) return;
      const sourceCard = event.target.closest?.('product-card');
      if (sourceCard && !sourceCard.contains(this)) return;
      try {
        const result = await event.promise;
        const detail = result?.detail;
        if (detail?.productId && String(detail.productId) !== this.component.dataset.productId) return;
        requestAnimationFrame(() => this.refresh());
      } catch {}
    }, { signal });
    this.refresh();
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  refresh() {
    const id = this.form.querySelector('input[name="id"]')?.value;
    const variant = this.variants.find(item => String(item.id) === String(id));
    const quantityInput = this.form.querySelector('input[name="quantity"]');
    const quantity = Number(quantityInput?.value || 1);
    this.querySelectorAll('input[type="radio"]').forEach(radio => {
      const count = Number(radio.value);
      const subtotal = Number(variant?.price || 0) * count;
      const amount = subtotal - Math.floor(Number(variant?.price || 0) * Number(radio.dataset.discount) / 100) * count;
      radio.closest('label').querySelector('[data-tier-price]').textContent = variant ? this.money.format(amount / 100) : '—';
      radio.checked = quantity === count;
      const maximum = quantityInput?.max ? Number(quantityInput.max) : Infinity;
      const minimum = Number(quantityInput?.min || 1);
      const step = Number(quantityInput?.step || 1);
      radio.disabled = !variant?.available || count > maximum || count < minimum || (count - minimum) % step !== 0;
    });
  }
}

if (!customElements.get('al-quantity-tiers')) customElements.define('al-quantity-tiers', AlQuantityTiers);
